import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Pipe,
  PipeTransform
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionnaireService } from '../../../../services/questionnaire/questionnaire.service';
import { IDwellingReturned } from './../../../../models/dwellingInput.interface';
import {
  IQuestionnaire,
  IQuestion
} from './../../../../models/questionnaire.interface';
import { IQualificationSubmission } from './../../../../models/qualification.interface';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { cloneDeep } from '@apollo/client/utilities/common/cloneDeep';

@Component({
  selector: 'ebb-house',
  templateUrl: './house.component.html',
  styleUrls: ['./house.component.scss']
})
export class HouseComponent implements OnInit {
  @Input() questionnaire$: Subject<IQuestionnaire>;
  @Input() dwelling$: Subject<IDwellingReturned>;
  @Input() drawerOpen: boolean;
  @Output() leaveForm: EventEmitter<number> = new EventEmitter<number>();
  @Output() isFormInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() qualify: EventEmitter<IQualificationSubmission> = new EventEmitter<
    IQualificationSubmission
  >();

  public _drawerContentError: SafeHtml;
  public _drawerContentHelp: SafeHtml;
  public _drawerContent: IQualificationSubmission;
  @Input()
  set drawerContent(data: IQualificationSubmission) {
    if (data) {
      this.drawerOpen = true;
      this._drawerContent = data;
      this._drawerContentError = this.formatHelptext(
        data.crmQualificationError
      );
      this._drawerContentHelp = this.formatHelptext(data.crmQualificationHelp);
    } else {
      this._drawerContent = null;
      this.drawerOpen = false;
    }
  }

  public sortedQuestions: IQuestion[][];
  public progressIndicator = 1;
  public progressDisplay: string;
  public questionForm: FormGroup;

  constructor(
    private questionnaireService: QuestionnaireService,
    public sanitizer: DomSanitizer
  ) {}

  public ngOnInit(): void {
    if (this.sortedQuestions) {
      return;
    }
    this.sortedQuestions = [];
    this.questionnaire$
      .subscribe(_questionnaire => {
         var questionnaire = cloneDeep(_questionnaire);
        let questionSetGroups: FormGroup[];
        if (questionnaire[0] && questionnaire[0].questions) {
          this.dwelling$.subscribe(data => {
            var questions: IQuestion[];
            questions = questionnaire[0].questions;
            var name = "addresschange" +data.id;
            var addresschange = this.getCookie(name);
            
          if( addresschange === "true"){
            questions.forEach(qual => {
              qual.inputSelectedValue = null;
              qual.inputSelectedValidStyle =null;
              var getcookievalue = this.getCookie(
                data.id + qual.id
              );
              if (getcookievalue !== null && getcookievalue !== undefined) {
               this.eraseCookie(data.id + qual.id) 
              }
             
            });
           
          }else{
            questions.forEach(qual => {
              var getcookievalue = this.getCookie(data.id + qual.id);
              if (getcookievalue !== null && getcookievalue !== undefined) {
                qual.inputSelectedValue = getcookievalue;
               
                
                var style = 'question-valid';
                if (qual.qualification) {
                  if (!qual.qualification.includes(qual.inputSelectedValue)) {
                    style = 'question-invalid';
                  }
                }
                
               qual.inputSelectedValidStyle =style;
              } else {

              }
            });
            
          }
          });
          this.sortedQuestions = this.questionnaireService.buildFormConfig(
            this.questionnaireService.questionSort(questionnaire[0].questions)
          );
         

          this.progressDisplay = this.progressBar();
          questionSetGroups = this.sortedQuestions.map(questionSet =>
            this.questionnaireService.buildSetFormGroup(questionSet)
          );
          this.questionForm = this.questionnaireService.buildQuestionnaire(
            ...questionSetGroups
          );
          //emit status of this form on each change
          this.questionForm.valueChanges.subscribe(x => {
            this.isFormInvalid.emit(this.questionForm.invalid);
          });
        }
      })
      .unsubscribe();
  }
  
  private eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  public nextPage(): void {
    if (this.progressIndicator < this.sortedQuestions.length) {
      this.progressIndicator++;
      this.scrollToTop();
    }
    this.progressDisplay = this.progressBar();
  }

  public previousPage(): void {
    if (this.progressIndicator > 1) {
      this.progressIndicator--;
      this.scrollToTop();
    } else {
      this.leaveForm.emit(-1);
      return;
    }
    this.progressDisplay = this.progressBar();
  }

  public scrollToTop() {
    const stepElement = document.getElementById('ebb-stepper-scroller-top');
    if (stepElement) {
      if (this.detectIE11()) {
        //IE11 has issues with scrollIntoView and will scroll html element horizontally
        window.scrollTo(0, stepElement.offsetTop);
      } else {
        setTimeout(() => {
          stepElement.scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth'
          });
        }, 250);
      }
    }
  }

  private detectIE11() {
    return window.navigator.userAgent.indexOf('Trident/') > 0;
  }

  public progressBar(): string {
    return `${Math.floor(
      (this.progressIndicator / this.sortedQuestions.length) * 100
    ).toString()}%`;
  }

  public emitQualification(qualification: IQualificationSubmission): void {
    this.qualify.emit(qualification);
  }
  public trimstring (str) {
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }
    return str;
}
public trimarray (stringarray :string[]){
  let array = [];
  stringarray.forEach(str=>{
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }
  array.push(str);});


  return array;
}
  public qualifierAnswered(answer: string, question: IQuestion): void {
    this.dwelling$
      .subscribe(data => {
        var name = data.id + question.id;
         question.inputValue =answer;
        question.inputSelectedValue = answer;


        var isValid = question.qualification.includes(answer);
        question.inputSelectedValidStyle = isValid
          ? 'question-valid'
          : 'question-invalid';

        this.setCookie(name, this.trimstring(answer), 1);
        const qualificationToSubmit: IQualificationSubmission = {
          response: answer,
          name: question.name,
          crmQualification: question.qualification,
          crmQualificationHelp: question.questionHelpMessage,
          crmQualificationError: question.questionErrorMessage,
          autoPopulateDwellingType: question.autoPopulateDwellingType,
          _Ebb_DwellingKey_Value: data.id,
          _Ebb_QuestionKey_Value: question.id
        };
        this.emitQualification(qualificationToSubmit);
      })
      .unsubscribe();
  }

  public qualifierOtherAnswered(other: Event, question: IQuestion): void {
    const target = other.target as HTMLInputElement;
    if (target.value.trim() === '') {
      return;
    }
    this.dwelling$
      .subscribe(data => {
        let answer = question.inputSelectedValue;
        var name = data.id + question.id + 'other';
        this.setCookie(name, answer, 1);
        if (answer.indexOf('-') > 0) {
          answer = answer.substr(0, answer.indexOf('-') - 1).trim();
          answer = answer + ' - ' + target.value;
        } else {
          answer = answer.trim() + ' - ' + target.value;
        }

        const qualificationToSubmit: IQualificationSubmission = {
          response: answer,
          name: question.name,
          crmQualification: question.qualification,
          crmQualificationHelp: question.questionHelpMessage,
          crmQualificationError: question.questionErrorMessage,
          autoPopulateDwellingType: question.autoPopulateDwellingType,
          _Ebb_DwellingKey_Value: data.id,
          _Ebb_QuestionKey_Value: question.id
        };
        this.emitQualification(qualificationToSubmit);
      })
      .unsubscribe();
  }

  public qualifierMoreInfo(question: IQuestion): void {
    this.dwelling$
      .subscribe(data => {
        const qualificationToSubmit: IQualificationSubmission = {
          response: null,
          name: question.name,
          crmQualification: question.qualification,
          crmQualificationHelp: question.questionHelpMessage,
          crmQualificationError: question.questionErrorMessage,
          autoPopulateDwellingType: question.autoPopulateDwellingType,
          _Ebb_DwellingKey_Value: data.id,
          _Ebb_QuestionKey_Value: question.id
        };
        this.emitQualification(qualificationToSubmit);
      })
      .unsubscribe();
  }
  public showMoreInfo(question: IQuestion): boolean {
    if (
      question.questionHelpMessage !== null &&
      question.questionHelpMessage.length > 0
    ) {
      return true;
    }
    return false;
  }

  public nextStepEnabled(progress: number): boolean {
    this.isFormInvalid.emit(this.questionForm.invalid);
    const progressField = this.questionForm.get(`set${progress}`);
    if (progressField) {
      return progressField.valid;
    }
    return false;
  }

  public formatHelptext(content: string): SafeHtml {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    resultHtml = this.youTubeLinks(resultHtml);
    resultHtml = this.vemioLinks(resultHtml);
    resultHtml = resultHtml.replace(/(\r\n|\n|\r)/gm, '<br/>');
    return this.sanitizer.bypassSecurityTrustHtml(resultHtml);
  }

  public youTubeLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createYoutubeEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public vemioLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createVimeoEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public createYoutubeEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://www.youtube.com/embed/' +
      key +
      '" frameborder="0" allowfullscreen></iframe></div>'
    );
  }

  public createVimeoEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://player.vimeo.com/video/' +
      key +
      '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>'
    );
  }
  private setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  private getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
